import { IEnquiry } from '@vivli/features/enquiry/infastructure/interface';
import { useEffect, useState } from 'react';
import { useActiveUserContext, useEnquiryApiContext } from '@vivli/core/infrastructure/context';
import { useParams } from 'react-router';
import { IUser } from '@vivli/shared/infrastructure/interface';
import { defaultDataInfoRequest } from '@vivli/features/enquiry/infastructure/wrappers';

const defaultValues = (user: IUser): IEnquiry => ({
    id: 0,
    requesterId: user.id,
    requesterEmail: user.email,
    requesterName: user.displayName,
    requesterOrganization: '',
    requesterCountry: '',
    enquiryPurpose: '',
    dataInfoRequests: [{ ...defaultDataInfoRequest }],
    status: 1,
    submittedDate: null,
    createdBy: '',
    updatedBy: '',
    createdDate: new Date().toDateString(),
    updatedDate: null,
    environment: ''
});

export const useEnquiry = () => {
    const [enquiry, setEnquiry] = useState<IEnquiry>();
    const { user } = useActiveUserContext();
    const { id } = useParams();

    const { getEnquiry } = useEnquiryApiContext();

    useEffect(() => {
        if (id) {
            getEnquiry(id).subscribe((data) => setEnquiry(data));
        } else if (!enquiry) {
            setEnquiry(defaultValues(user));
        }
    }, [id]);

    return {
        enquiry,
        setEnquiry
    };
};
